export function getOption<T>(value: T, text: string) {
    return {
        key: value,
        value,
        text,
    };
}

export function getActionOption<T>(value: string, text: string, onClick: (data: T) => void) {
    return {
        key: value,
        size: 'mini',
        text,
        value,
        onClick,
    };
}

export type ActionOptionType<T> = ReturnType<typeof getActionOption<T>>;
